<template>
    <ul id="purchase-history">
        <li v-for="history in histories" class="screen-transition" @click="select(history.item_id, $event)">
            <div class="item-image">
                <img :src="'/item/image/'+history.item_id" class="profile-image">
            </div>
            <div class="item-info">
                <div class="purchase-date">{{ toDate(history.ltime) }} {{ characters.purchase }}</div>
                <div v-if="!checkIsDigitalContent(history.item_type)" class="item-title">{{ history.title }}</div>
                <div v-if="checkIsDigitalContent(history.item_type) && history.digicon_id==0 && history.count==''" class="item-title">{{ history.title }}</div>
                <div v-if="checkIsDigitalContent(history.item_type) && history.digicon_id==0 && history.count!=''" class="item-title">{{ history.title + '(' + history.count + characters.number_of_music + ')' }}</div>
                <div v-if="checkIsDigitalContent(history.item_type) && history.digicon_id!=0" class="item-title">{{ history.title + '(' + history.digicon_title + ')'}}</div>
            </div>
            <div class="item-price-container">
                <span v-if="history.item_type=='goods' && 1<history.num" class="item-price" style="margin:0px 10px;">{{ history.num }}</span>
                <span class="item-price">{{ '￥' + history.price.toLocaleString() }}</span>
            </div>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "purchase-history",
        props: ['json_characters'],
        mounted() {
            // console.log('purchase-history mounted');

            axios
                .default
                .get('/getPurchaseHistory')
                .then(response => {
                    // console.log(response.data);
                    this.histories = response.data;
                });
            this.characters = JSON.parse(this.json_characters);
        },
        data: function () {
            return {
                histories: [],
                characters: Object,
            }
        },
        methods: {
            select: function (s, event) {
                // console.log(s);
                if (s) {
                    const item_id = Number(s);
                    location.href = `/store/${item_id}`;
                }
            },
            toDate: function (datetime) {
                let year = datetime.slice(0, 4);
                let month = datetime.slice(5, 7);
                let day = datetime.slice(8, 10);
                return year + "." + month + "." +day;
            },
            checkIsDigitalContent: function(type) {
                const digital_content = ['music', 'video', 'photo'];
                return digital_content.indexOf(type) > -1;
            },
        }
    }
</script>

<style scoped>

</style>
